{
  "carrierLabel": "Компания-перевозчик",
  "searchPlaceholder": "Поиск по названию",
  "selectAsCarrier": "Выбрать \"{name}\" в качестве перевозчика",
  "typeToSearch": "Введите для поиска компании"
}
